
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36 44a2.445 2.445 0 010-4.888h9.6a2.445 2.445 0 010 4.888zM0 26.888A16.959 16.959 0 0116.8 9.777a16.96 16.96 0 0116.8 17.111A16.959 16.959 0 0116.8 44 16.957 16.957 0 010 26.888zm4.8 0a12.115 12.115 0 0012 12.223 12.224 12.224 0 000-24.444 12.113 12.113 0 00-12 12.221zm36 7.335a2.446 2.446 0 010-4.891h4.8a2.446 2.446 0 010 4.891zm-27.1-2.367a2.427 2.427 0 01-1.773-1.806 2.471 2.471 0 01.773-2.427l1.7-1.736V22a2.4 2.4 0 114.8 0v4.888a2.466 2.466 0 01-.719 1.736l-2.4 2.444a2.37 2.37 0 01-2.383.788zm27.1-7.412a2.445 2.445 0 010-4.888h4.8a2.445 2.445 0 010 4.888zM36 14.667a2.446 2.446 0 010-4.891h9.6a2.446 2.446 0 010 4.891zM2.4 4.888A2.421 2.421 0 010 2.444 2.421 2.421 0 012.4 0h43.2A2.421 2.421 0 0148 2.444a2.421 2.421 0 01-2.4 2.444z","fill":"#fff"}})])
          )
        }
      }
    